<template>
  <div>
    <div class="text-center">
      <div>
        <h2>Member Profile</h2>
      </div>

      <div>
        <p>Update member information</p>
      </div>
    </div>
    <b-tabs align="center">
      <b-tab title="Personal">
        <MemberProfileIndex />
      </b-tab>
      <b-tab title="Education">
        <EducationHistoryList :is-personal="true" :user-id="currentUser._id" />
      </b-tab>
      <b-tab title="Work Experience">
        <WorkExperienceList :is-personal="true" :user-id="currentUser._id" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>

import { BTabs, BTab } from 'bootstrap-vue'
import MemberProfileIndex from "@/@core/components/user-profile/member-index.vue";
import EducationHistoryList from "@/@core/components/education/EducationHistoryList.vue";
import WorkExperienceList from "@/@core/components/work-experience/WorkExperienceList.vue";

export default {
  name: 'MemberProfileDetail',
  components: {
    BTabs,
    BTab,
    MemberProfileIndex,
    WorkExperienceList,
    EducationHistoryList,
  },
}
</script>
